<style scoped lang="less" rel="stylesheet/less" scoped>
.countDown {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  position: absolute;
  bottom: 7px;
  bottom: -73px;
  left: 50%;
  z-index: 96;
  margin-left: -33px;
  animation-fill-mode: both;
  .count_down_ico {
    width: 66px;
    height: 66px;
    background: url(../../../assets/img/video/countDown.png) center no-repeat;
    background-size: 100%;
  }
  .count_down_ico_gif {
    background: url(../../../assets/img/video/countDown.gif) center top
      no-repeat;
    background-color: #ffffff;
    background-size: 100%;
    border-radius: 50%;
  }
  .count_down_num {
    width:63px;
    height: 63px;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    bottom: 84px;
    text-align: center;
    overflow: hidden;
    box-shadow: -0px -0px 12px 6px rgba(0, 0, 0, 0.26);
    font-family: Roboto_Medium;
    background: url(../../../assets/img/video/roundBG.png) center no-repeat;
    background-size: 100%;
    .demo {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      line-height: 50px;
      font-size: 30px;
      color: #333333;
      overflow: hidden;
    }
    .box {
      transition: transform 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
    span {
      height: 55px;
      display: block;
    }
    .count_down_num--red {
      color: #f56c22;
    }
    .big {
      position: absolute;
      width: 100%;
      height: 100%;
      font-size: 40px;
      line-height: 55px;
      animation: countDownBig 1s 5 cubic-bezier(0.23, 1, 0.32, 1);
      em{
        opacity: 0;
        visibility: hidden;
      }
    }
    // &:after {
    //   position: absolute;
    //   left: 50%;
    //   margin-left: -8px;
    //   bottom: -7px;
    //   content: "";
    //   width: 0;
    //   height: 0;
    //   border: 8px solid #fff;
    //   border-left: 10px solid transparent;
    //   border-top: 10px solid transparent;
    //   border-bottom-right-radius: 5px;
    //   transform: rotate(45deg);
    // }
  }
}
</style>
<template>
  <div class="countDown">
<!--     <div class="count_down_ico" v-show="countDownValNum>5"></div>
    <div class="count_down_ico count_down_ico_gif" v-show="countDownValNum<=5"></div> -->
    <div class="count_down_num">
      <div :class="{'count_down_num--red':countDownValNum<=5}" class="demo">
        <div
          v-for="(val,ind) in countDownValArr"
          :class="{'box':countDownValNum>5 && countDownValArr[ind]!=9}"
          :key="ind"
          :style="{transform:'translate3d(0,'+(9-countDownValArr[ind])*55+'px,0)'}"
        >
          <span v-text="ind+1===countDownValArr.length?'9\'':9"></span>
          <span v-for="i in 10" :key="i" v-text="ind+1===countDownValArr.length?i-1+'\'':i-1"></span>
        </div>
      </div>
      <span class="big count_down_num--red" v-show="countDownValNum<=5">0{{countDownValNum}}<em>'</em></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "countDown",
  data() {
    return {
      countDownValArr: [],
      countDownValNum: 0,
      interval:null
    };
  },
  props: {
    countDownVal: {
      required:true,
      type:Number
    }
  },
  mounted() {
    this.countDownValNum = this.countDownVal;
    this.$nextTick(()=>{
      this.changeArr();
      this.interval = setInterval(() => {
        this.countDownValNum--;
        this.changeArr();
        if (this.countDownValNum <= 0) {
          this.$emit("closeClock","countDown");
          clearInterval(this.interval);
          return;
        }
      }, 1000);
    })

  },
  methods: {
    changeArr() {
      let str =
        this.countDownValNum < 10
          ? "0" + this.countDownValNum
          : "" + this.countDownValNum;
      this.countDownValArr = str.split("");
      if ((this.countDownValNum+1) % 10 === 0) {
        let len = this.countDownValArr.length - 1;
        this.$set(this.countDownValArr, len, -1);
        setTimeout(() => {
          this.$set(this.countDownValArr, len, 9);
        }, 400);
      }
    }
  },
  destroyed() {
    clearInterval(this.interval);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness/video/countDown.vue